import { ax } from '../utils/axios/axios';
import { BASE_API_URL } from '../constants';
import { RoleId } from '@src/types/common/RoleId';

interface UpdateOptions {
  overtimeId: number;
  reasonCode: string;
  serialId: number;
}

export const apiOvertimeReasonUpdate = (options: UpdateOptions) => {
  const { overtimeId, reasonCode, serialId } = options;

  const axOptions = {
    method: 'PUT',
    url: `${BASE_API_URL}/labour`,
    params: {
      overtimeId: overtimeId,
      reqSid: serialId,
      reqRole: RoleId.ProjectManager, // or whatever role you want
      reqDev: 'web',
    },
    data: {
      reasonCode: reasonCode,
    },
  };

  return ax(axOptions);
};
